<div class="sidebar" [class.collapsed]="collapsed">
  <!-- Logo Section -->
  <div class="logo-section">
    @if (!collapsed) {
      <div class="logo-container">
        <a routerLink="/admin/dashboard" class="logo-link">
          <div class="logo-icon">
            <img 
              src="assets/images/logo.svg" 
              alt="CLOCC THAT TEA" 
              class="balloon-logo"
              (error)="logoLoadError = true"
              *ngIf="!logoLoadError">
            <div class="image-not-found" *ngIf="logoLoadError">Not found</div>
          </div>
        </a>
        <button class="sidebar-hamburger" type="button" (click)="onToggleSidebar()" aria-label="Toggle sidebar" title="Toggle sidebar">
          <i class="pi pi-bars"></i>
        </button>
      </div>
    }

    @if (collapsed) {
      <div class="collapsed-logo-container" (click)="onToggleSidebar()" title="Expand sidebar">
        <img 
          src="assets/favicon/clccthattea-v2-icon-main.png" 
          alt="CLOCC THAT TEA" 
          class="collapsed-brand-icon">
      </div>
    }
  </div>

  <!-- Navigation Menu -->
  <nav class="nav-menu">
    <ul class="nav-list">
      <li class="nav-item" 
          *ngFor="let item of menuItems" 
          [class.active]="isActive(item.route)"
          (click)="setTitle(item.label)">
        <a class="nav-link" 
           [routerLink]="item.route" 
           routerLinkActive="active">
          <i class="nav-icon" [class]="item.icon"></i>
          <span class="nav-label" *ngIf="!collapsed">{{ item.label }}</span>
        </a>
      </li>
    </ul>
  </nav>
</div>
